import React, { useState } from "react";
import { useSelector } from "react-redux";
import { PopupPropsContext } from "@progress/kendo-react-popup";
import { icon, label, number } from "../../config";
import { sanitizeHtmlString } from "../../helper/common";
import { usePopup } from "../../helper/commonHooks";
import { highlightWords, isTrueBit } from "../../utils/common";
import RelationList from "./RelationList";

/**
 * overall Search items List
 * Parent Comp. - overallSeachItems
 * @author Himanshu
 */
const SearchResultItem = ({ item, handleOnClick, entityResults, searchText, idx, index, getItemClass, entityName, setShowPopup }) => {
  const { show, setShow, anchor, contentRef, blurTimeoutRef, onOpen, onFocus, onBlur } = usePopup();
  const [isHovered, setIsHovered] = useState(false);
  const [mediationIconRef, setMediationIconRef] = useState(null);
  const [isTriggeredByIcon, setIsTriggeredByIcon] = useState(false);

  /**
   * Handles mouse enter event to show hover state
   * @author Muskan Thakur
   */
  const handleMouseEnter = () => {
    setIsHovered(true);
  };

  /**
   * Handles mouse leave event to hide hover state when popup is not shown
   * @author Muskan Thakur
   */
  const handleMouseLeave = () => {
    if (!show) {
      setIsHovered(false);
    }
  };

  /**
   * Handles click on the task item
   * @author Muskan Thakur
   */
  const handleTaskClick = () => {
    if (entityName === label.LINKED_TASK) {
      setIsTriggeredByIcon(false);
      setShow(!show);
    } else {
      setIsHovered(false);
      setShow(false);
      handleOnClick(entityResults, item);
    }
  };

  /**
   * Handles click on the link icon to open relation list
   * @author Muskan Thakur
   */
  const handleMediationIconClick = (e) => {
    e.stopPropagation();
    setIsTriggeredByIcon(true);
    setIsHovered(false);
    setShow(!show);
  };

  /**
   * Handles popup close and cleans up state
   * @author Muskan Thakur
   */
  const handlePopupClose = () => {
    setShow(false);
    setIsHovered(false);
    setIsTriggeredByIcon(false);
  };

  return (
    <React.Fragment>
      <div
        key={item.Id}
        className='search-results'
        onClick={handleTaskClick}
        ref={anchor}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}>
        <div className={getItemClass(item, idx, index)}>
          <div className='single-result-info'>
          {!!(item.IsTaskClosed ) && (
              <span className='mr-2'>{icon.CIRCLE_CHECK_GREEN}</span>
            )}
            {item.Code && (
              <span className='code-section text-nowrap mr-2 ' dangerouslySetInnerHTML={{ __html: sanitizeHtmlString(highlightWords(item.Code, searchText)) }}></span>
            )}
            {item.Name && (
              <span className='name-section ' dangerouslySetInnerHTML={{ __html: sanitizeHtmlString(highlightWords(item.Name, searchText)) }}></span>
            )}
          </div>
          <div className='single-result-icons d-flex align-items-center'>
            {item.isTagMatch && <span className='icon-alignment d-flex align-items-center justify-content-center'>{icon.TAG}</span>}
            {(isHovered || show) && entityName === label.LINKED_TASK && (
              <span
                ref={setMediationIconRef}
                className='icon-alignment d-flex align-items-center justify-content-center mediation-hover-icon'
                onClick={handleMediationIconClick}>
                {icon.MEDIATION}
              </span>
            )}
          </div>
        </div>
      </div>
      {entityName == label.LINKED_TASK && (
        <PopupPropsContext.Provider
          value={(props) => ({
            ...props,
            appendTo: isTriggeredByIcon && mediationIconRef ? mediationIconRef : anchor.current,
          })}>
          <RelationList
            anchor={isTriggeredByIcon && mediationIconRef ? { current: mediationIconRef } : anchor}
            show={show}
            setShowPopup={setShowPopup}
            selectedItem={item}
            relationListRef={contentRef}
            blurTimeoutRef={blurTimeoutRef}
            onOpen={onOpen}
            onFocus={onFocus}
            onBlur={onBlur}
            setShow={setShow}
            isTriggeredByIcon={isTriggeredByIcon}
            handlePopupClose={handlePopupClose}
          />
        </PopupPropsContext.Provider>
      )}
    </React.Fragment>
  );
};

export default SearchResultItem;
